import { Routes } from '@angular/router';
import { basketLoadingGuard } from '@domgen/dgx-fe-basket';
import { CmsPageComponent, cmsPageTemplateResolver } from '@domgen/dgx-fe-cms';
import { RegistrationGaCategory } from '@us-registration/util-models';

export const REGISTRATION_FEATURE_PROTECTION_DETAILS_WIB_ROUTES: Routes = [
  {
    path: '',
    component: CmsPageComponent,
    data: {
      cmsNodePath: '/protection-details-wib',
      gaData: {
        category: RegistrationGaCategory.Pages,
      },
    },
    resolve: {
      cmsPageTemplate: cmsPageTemplateResolver,
    },
    canDeactivate: [basketLoadingGuard],
  },
];
